import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
export const getToken = () => localStorage.getItem("fbwm_token") || "";
api.interceptors.request.use((c) => { c.headers["X-Lang"] = localStorage.getItem("fbwm_lang") || "it"; if (getToken()) c.headers.Authorization = `Bearer ${getToken()}`; return c; });
api.interceptors.response.use((r) => r, (e) => { if (e.response?.status === 401 && e.response?.data?.detail === "PIN richiesto") { localStorage.removeItem("fbwm_token"); window.dispatchEvent(new Event("fbwm-pin-required")); } return Promise.reject(e); });
export const authUrl = (path, params = {}) => { const u = new URL(`${process.env.REACT_APP_BACKEND_URL}/api${path}`); Object.entries({ ...params, token: getToken(), lang: localStorage.getItem("fbwm_lang") || "it" }).forEach(([k, v]) => u.searchParams.set(k, v)); return u.toString(); };
const loc = () => ((localStorage.getItem("fbwm_lang") || "it") === "en" ? "en-GB" : "it-IT");

export const MATURITY = {
  consolidato: { label: "Consolidato", bg: "#064E3B", text: "#6EE7B7", border: "#047857" },
  parziale: { label: "Parziale", bg: "#78350F", text: "#FDE68A", border: "#B45309" },
  da_approfondire: { label: "Da approfondire", bg: "#4C1D95", text: "#DDD6FE", border: "#6D28D9" },
};

export const NATURE = {
  teoria: { label: "Teoria", bg: "#1E3A8A", text: "#93C5FD", border: "#1D4ED8" },
  dato_operativo: { label: "Dato operativo", bg: "#14532D", text: "#86EFAC", border: "#15803D" },
  strumento_decisionale: { label: "Strumento decisionale", bg: "#701A75", text: "#F0ABFC", border: "#A21CAF" },
};

export const SEVERITY = {
  critico: { label: "Critico", color: "#EF4444" },
  attenzione: { label: "Attenzione", color: "#F59E0B" },
  opportunita: { label: "Opportunità", color: "#3B82F6" },
  ok: { label: "In linea", color: "#10B981" },
  promemoria: { label: "Promemoria", color: "#A19B93" },
};

export const CATEGORY_COLORS = { stella: "#10B981", cavallo: "#3B82F6", enigma: "#F59E0B", cane: "#EF4444" };

export const BRANCH_COLORS = {
  core_economic: "#E67E22", compliance: "#3498DB", growth: "#2ECC71", territory: "#F1C40F",
  taste: "#9B59B6", hospitality: "#E74C3C", meta: "#1ABC9C", events: "#F472B6",
};

export const BRANCH_TITLES = {
  core_economic: "Core Economic", compliance: "Compliance", growth: "Growth", territory: "Territorio / Prodotto",
  taste: "Gusto & Semantica", hospitality: "Hospitality", meta: "Meta-Layer", events: "Eventi",
};

export const TOOL_ROUTES = {
  foodcost: "/calcolatori?tab=foodcost", pricing: "/calcolatori?tab=pricing", menu: "/calcolatori?tab=menu",
  kpi: "/calcolatori?tab=kpi", events: "/eventi", cockpit: "/cockpit",
};

export const eur = (n) => new Intl.NumberFormat(loc(), { style: "currency", currency: "EUR", maximumFractionDigits: 2 }).format(n ?? 0);
export const pct = (n) => `${Number(n ?? 0).toLocaleString(loc(), { maximumFractionDigits: 1 })}%`;
